import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_74b238ff/src/views/ForgotPassword.tsx");
